import './styles.css';
import { GameApp } from './app';

const canvas = document.getElementById('scene') as HTMLCanvasElement;
const ui = document.getElementById('ui') as HTMLElement;

const app = new GameApp(canvas, ui);
if (import.meta.env.DEV) (window as unknown as { __ansoku: GameApp }).__ansoku = app;
app.init().catch((err) => {
  console.error('Failed to start Ansoku:', err);
  document.body.insertAdjacentHTML(
    'beforeend',
    `<div class="loading">Failed to load. Check the console.</div>`,
  );
});
